import mod from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VersionCard.Vue?vue&type=script&lang=js"; export default mod; export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VersionCard.Vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./src/components/VersionCard.Vue?vue&type=script&lang=js
// module id = 82
// module chunks = 0